import { useAuthStore } from '@/stores/authStore'
import { clearToken, ensureToken, safeLogout } from '@/lib/sso'
import { Button } from '@/components/shadcn/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card'

export default function SSODebugPage() {
  const { user, token, isAuthenticated } = useAuthStore()

  console.log('=== SSODebugPage 渲染 ===')
  console.log('当前用户信息:', user)
  console.log('当前token状态:', token ? '已设置' : '未设置')
  console.log('认证状态:', isAuthenticated)
  console.log('localStorage token:', localStorage.getItem('access_token') ? '存在' : '不存在')

  const handleLogout = () => {
    console.log('=== 开始登出流程 ===')
    console.log('当前URL:', window.location.href)
    console.log('当前路径:', window.location.pathname)
    console.log('执行safeLogout...')
    safeLogout()
  }

  const handleForceLogin = () => {
    console.log('=== 强制登录检查 ===')
    console.log('当前URL:', window.location.href)
    console.log('当前路径:', window.location.pathname)
    console.log('执行ensureToken...')
    ensureToken()
  }

  const handleCheckToken = () => {
    console.log('=== 检查Token状态 ===')
    const localToken = localStorage.getItem('access_token')
    console.log('localStorage中的token:', localToken)
    console.log('token长度:', localToken ? localToken.length : 0)
    console.log('当前路径:', window.location.pathname)
    console.log('当前URL:', window.location.href)
    console.log('URL hash:', window.location.hash)
    console.log('URL search:', window.location.search)
    
    if (localToken) {
      console.log('token前50个字符:', localToken.substring(0, 50) + '...')
      
      // 尝试解析JWT
      try {
        const parts = localToken.split('.')
        console.log('JWT parts数量:', parts.length)
        
        if (parts.length >= 2) {
          // 解析header
          const headerBase64 = parts[0].replace(/-/g, '+').replace(/_/g, '/')
          const paddedHeader = headerBase64.padEnd(headerBase64.length + (4 - (headerBase64.length % 4)) % 4, '=')
          const headerJson = atob(paddedHeader)
          const header = JSON.parse(headerJson)
          console.log('JWT Header:', header)
          
          // 解析payload
          const payloadBase64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
          const paddedPayload = payloadBase64.padEnd(payloadBase64.length + (4 - (payloadBase64.length % 4)) % 4, '=')
          const payloadJson = atob(paddedPayload)
          const payload = JSON.parse(payloadJson)
          console.log('JWT Payload:', payload)
          
          // 检查过期时间
          if (payload.exp) {
            const now = Math.floor(Date.now() / 1000)
            const exp = payload.exp
            const timeLeft = exp - now
            console.log('Token过期时间:', new Date(exp * 1000).toISOString())
            console.log('当前时间:', new Date(now * 1000).toISOString())
            console.log('剩余时间(秒):', timeLeft)
            console.log('是否已过期:', timeLeft <= 0)
          }
        }
      } catch (jwtError) {
        console.warn('JWT解析失败:', jwtError)
      }
    }
  }

  const handleClearToken = () => {
    console.log('=== 清除Token ===')
    console.log('清除前的localStorage token:', localStorage.getItem('access_token'))
    localStorage.removeItem('access_token')
    console.log('清除后的localStorage token:', localStorage.getItem('access_token'))
    console.log('Token已清除')
  }

  const handleTestSSOFlow = () => {
    console.log('=== 测试SSO流程 ===')
    console.log('当前环境变量VITE_SSO_ISSUE_URL:', import.meta.env.VITE_SSO_ISSUE_URL)
    console.log('当前origin:', window.location.origin)
    console.log('回调URL:', `${window.location.origin}/sso/callback`)
    console.log('当前完整URL:', window.location.href)
    
    const targetUrl = window.location.href
    const encodedReturnTo = encodeURIComponent(targetUrl)
    const callbackUrl = `${window.location.origin}/sso/callback`
    const ssoUrl = `${import.meta.env.VITE_SSO_ISSUE_URL || 'https://user-center.example.com/sso/issue'}?return_to=${encodedReturnTo}&callback_url=${encodeURIComponent(callbackUrl)}`
    
    console.log('目标URL:', targetUrl)
    console.log('编码后的return_to:', encodedReturnTo)
    console.log('回调URL:', callbackUrl)
    console.log('完整SSO URL:', ssoUrl)
  }

  return (
    <div className="container mx-auto p-6 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>SSO 调试页面</CardTitle>
          <CardDescription>
            用于调试SSO登出流程
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <h3 className="font-semibold mb-2">当前状态</h3>
            <p>路径: {window.location.pathname}</p>
            <p>已认证: {isAuthenticated ? '是' : '否'}</p>
            <p>Token: {token ? '已设置' : '未设置'}</p>
            <p>localStorage token: {localStorage.getItem('access_token') ? '存在' : '不存在'}</p>
          </div>

          {user && (
            <div>
              <h3 className="font-semibold mb-2">用户信息</h3>
              <p>姓名: {user.name}</p>
              <p>邮箱: {user.email}</p>
              <p>计划: {user.plan}</p>
            </div>
          )}

          <div className="flex flex-wrap gap-2">
            <Button onClick={handleLogout} variant="destructive">
              登出测试
            </Button>
            <Button onClick={handleForceLogin} variant="outline">
              强制登录检查
            </Button>
            <Button onClick={handleCheckToken} variant="secondary">
              检查Token状态
            </Button>
            <Button onClick={handleClearToken} variant="outline">
              清除Token
            </Button>
            <Button onClick={handleTestSSOFlow} variant="outline">
              测试SSO流程
            </Button>
          </div>

          <div className="text-sm text-muted-foreground">
            <p>• 点击"登出测试"应该跳转到 /logout 页面</p>
            <p>• 点击"强制登录检查"会检查token并可能跳转</p>
            <p>• 点击"检查Token状态"会详细分析当前token</p>
            <p>• 点击"清除Token"会清除localStorage中的token</p>
            <p>• 点击"测试SSO流程"会显示SSO跳转URL信息</p>
            <p>• 打开浏览器控制台查看详细日志</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
